import Vue from 'vue'
import VueI18n from "vue-i18n";
import {localRead} from '@/libs/util';
import customZhCn from './lang/zh-CN';
import customEnUs from './lang/en-US';
import customZhTw from './lang/zh-TW';
import zhCnLocale from 'view-design/src/locale/lang/zh-CN'
import zhTwLocale from 'view-design/src/locale/lang/zh-TW'
import enUsLocale from 'view-design/src/locale/lang/en-US'

Vue.use(VueI18n)

const navLang = navigator.language || navigator.browserLanguage
//原先逻辑
//const localLang = (navLang === 'zh-CN' || navLang === 'en' || navLang === 'en-US') ? (navLang === 'en' ? 'en-US' : navLang) : false

//20210412 修改为不是中文则显示英文
const localLang = (navLang === 'zh-CN') ? 'zh-CN' : ((navLang === 'zh-TW') ? 'zh-TW' : 'en-US')

// 优先用用户已选语言，避免刷新时浏览器语言覆盖导致标签页标题偶发中文
const savedLang = localRead('local')
let lang = (savedLang === 'zh-CN' || savedLang === 'zh-TW' || savedLang === 'en-US')
  ? savedLang
  : (localLang || 'zh-CN')
Vue.config.lang = lang

Vue.locale = () =>{}
const messages = {
  'zh-CN': Object.assign(zhCnLocale, customZhCn),
  'zh-TW': Object.assign(zhTwLocale, customZhTw),
  'en-US': Object.assign(enUsLocale, customEnUs)
}

const i18n = new VueI18n({
  locale: lang,
  messages
})
export default i18n



// WEBPACK FOOTER //
// ./src/locale/index.js